export const outreachPrograms = ["Explore", "Challenge", "FTC", "FRC"] as const;
